import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faOilCan, faChartPie, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const LipidomeReport = ({ id, type, data }) => {
    // Placeholder data
    const lipidomeData = data || {
        lipidProfile: {
            totalCholesterol: 195,
            ldl: 118,
            hdl: 52,
            triglycerides: 125,
            status: 'Normal'
        },
        lipidClasses: [
            { name: 'Phospholipids', percentage: 35, status: 'Normal' },
            { name: 'Glycerolipids', percentage: 28, status: 'Normal' },
            { name: 'Sphingolipids', percentage: 15, status: 'Low' },
            { name: 'Sterols', percentage: 12, status: 'High' },
            { name: 'Free Fatty Acids', percentage: 10, status: 'Normal' }
        ],
        riskFactors: [
            { factor: 'Cardiovascular Risk', level: 'Low', description: 'Healthy HDL/LDL ratio' },
            { factor: 'Inflammation', level: 'Moderate', description: 'Slightly elevated omega-6/omega-3 ratio' },
            { factor: 'Metabolic Health', level: 'Good', description: 'Normal triglyceride levels' }
        ]
    };

    return (
        <div className="OmicsView-lipidome-report">
            <h3>Lipidome Report for {id}</h3>
            <div className="OmicsView-lipidome-content">
                <div className="OmicsView-lipidome-section">
                    <h4>
                        <FontAwesomeIcon icon={faOilCan} /> Lipid Profile
                    </h4>
                    <div className="OmicsView-lipidome-profile">
                        <div className={`OmicsView-lipidome-profile-status status-${lipidomeData.lipidProfile.status.toLowerCase()}`}>
                            {lipidomeData.lipidProfile.status} Profile
                        </div>
                        <div className="OmicsView-lipidome-profile-metrics">
                            <div className="OmicsView-lipidome-metric">
                                <div className="OmicsView-lipidome-metric-value">
                                    {lipidomeData.lipidProfile.totalCholesterol}
                                </div>
                                <div className="OmicsView-lipidome-metric-label">
                                    Total Cholesterol
                                </div>
                                <div className="OmicsView-lipidome-metric-unit">
                                    mg/dL
                                </div>
                            </div>
                            <div className="OmicsView-lipidome-metric">
                                <div className="OmicsView-lipidome-metric-value">
                                    {lipidomeData.lipidProfile.ldl}
                                </div>
                                <div className="OmicsView-lipidome-metric-label">
                                    LDL
                                </div>
                                <div className="OmicsView-lipidome-metric-unit">
                                    mg/dL
                                </div>
                            </div>
                            <div className="OmicsView-lipidome-metric">
                                <div className="OmicsView-lipidome-metric-value">
                                    {lipidomeData.lipidProfile.hdl}
                                </div>
                                <div className="OmicsView-lipidome-metric-label">
                                    HDL
                                </div>
                                <div className="OmicsView-lipidome-metric-unit">
                                    mg/dL
                                </div>
                            </div>
                            <div className="OmicsView-lipidome-metric">
                                <div className="OmicsView-lipidome-metric-value">
                                    {lipidomeData.lipidProfile.triglycerides}
                                </div>
                                <div className="OmicsView-lipidome-metric-label">
                                    Triglycerides
                                </div>
                                <div className="OmicsView-lipidome-metric-unit">
                                    mg/dL
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="OmicsView-lipidome-section">
                    <h4>
                        <FontAwesomeIcon icon={faChartPie} /> Lipid Classes Distribution
                    </h4>
                    <div className="OmicsView-lipidome-classes">
                        <div className="OmicsView-lipidome-chart">
                            {/* This would be a pie chart in a real implementation */}
                            <div className="OmicsView-lipidome-chart-placeholder">
                                Lipid Classes Pie Chart
                            </div>
                        </div>
                        <div className="OmicsView-lipidome-classes-list">
                            {lipidomeData.lipidClasses.map((lipidClass, index) => (
                                <div key={index} className="OmicsView-lipidome-class">
                                    <div className="OmicsView-lipidome-class-name">
                                        {lipidClass.name}
                                    </div>
                                    <div className="OmicsView-lipidome-class-bar-container">
                                        <div 
                                            className={`OmicsView-lipidome-class-bar status-${lipidClass.status.toLowerCase()}`}
                                            style={{ width: `${lipidClass.percentage * 2}%` }}
                                        ></div>
                                    </div>
                                    <div className="OmicsView-lipidome-class-percentage">
                                        {lipidClass.percentage}%
                                    </div>
                                    <div className={`OmicsView-lipidome-class-status status-${lipidClass.status.toLowerCase()}`}>
                                        {lipidClass.status}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                
                <div className="OmicsView-lipidome-section">
                    <h4>
                        <FontAwesomeIcon icon={faExclamationTriangle} /> Risk Assessment
                    </h4>
                    <div className="OmicsView-lipidome-risks">
                        {lipidomeData.riskFactors.map((risk, index) => (
                            <div key={index} className={`OmicsView-lipidome-risk level-${risk.level.toLowerCase()}`}>
                                <div className="OmicsView-lipidome-risk-header">
                                    <span className="OmicsView-lipidome-risk-factor">{risk.factor}</span>
                                    <span className="OmicsView-lipidome-risk-level">{risk.level}</span>
                                </div>
                                <div className="OmicsView-lipidome-risk-description">
                                    {risk.description}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LipidomeReport;
